//TODO: Remove the unused interfaces after hooking up with backend data

enum ModalForm {
    ADD_CREW = 'addCrew',
    EDIT_CREW = 'editCrew',
    EMPTY = '',
}

export interface Option {
    id: number | string;
    name: string | number;
    disabled?: boolean;
}

export { ModalForm };
